module.exports = __webpack_public_path__ + "static/media/im-pop-up-my-montepio-diogo-picarra.bd1b6d14.png";